var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"inline-block rounded-full px-2 py-0.5 text-xs font-medium",class:_vm.colorClass},[_vm._v("\n  "+_vm._s(_vm.$t(`KNOWLEDGE_BASE.STATUSES.${_vm.status.toUpperCase()}`))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }